import React, { useState, handlelick, active, useContext } from "react";
import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChild,
  faCircleInfo,
  faDatabase,
  faEnvelope,
  faMoneyBill,
  faNewspaper,
  fas,
  faSliders,
  faSuitcase,
  faUserGroup,
  faUsers,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { Context } from "../../utils/context";
import { faAffiliatetheme } from "@fortawesome/free-brands-svg-icons";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";

import { IDS, RoleId } from "../../utils/common";
import { getData } from "../../utils/api";

library.add(fas);

const Sidebar = () => {
  const { isSidebarOpen, setSidebarOpen, isAllow, IMG_URL } =
    useContext(Context);
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(true);
  const [showItemNames, setShowItemNames] = useState(true);
  const [headerText, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [active, setActive] = useState("0");
  const handleClick = (eventKey) => {
    if (active === eventKey) {
      setActive(null);
    } else {
      setActive(eventKey);
      // setSidebarOpen(true);
    }
  };

  const isActive = (path) => {
    return location.pathname.includes(path) ? "active block" : "none";
  };

  const [show, setShow] = useState(false);

  const [user, setUser] = useState({});
  const [alerts, setAlert] = useState({});

  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };

  const GetAlerts = async () => {
    const response = await getData(`/admin/alerts/alert-data`);
    if (response?.success) {
      setAlert(response?.data);
    }
  };

  useEffect(() => {
    GetUser();
    GetAlerts();
  }, []);

  const [appSetup, setAppSetup] = useState({});
  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);
    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  console.log("user?.role_id", user?.role_id);

  const isBroker = Number(user?.role_id) === Number(RoleId.Broker);
  const isAdmin = Number(user?.role_id) === Number(RoleId.Admin);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section className="sidebar">
        <div className="desktop-view-sidebar">
          <div className="top_section">
            {Number(user?.role_id) === RoleId.Admin ? (
              <Link to="/advanceDashboard" className="logo_holder">
                <img
                  className="logo"
                  src={IMG_URL + appSetup?.logo}
                  alt="Logo"
                />
              </Link>
            ) : (
              <div className="logo_holder">
                <img
                  className="logo"
                  src={IMG_URL + appSetup?.logo}
                  alt="Logo"
                />
              </div>
            )}
          </div>
          <ul className="list-unstyled ps-0">
            {/* ***************************************************Dashboard*************************************************************** */}

            <Accordion
              // defaultActiveKey="0"
              className="mb-"
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded="false"
            >
              {Number(user?.role_id) === RoleId.Admin && (
                <Accordion.Item
                  eventKey="0"
                  className="mb-"
                  onClick={() => handleClick("0")}
                >
                  <Accordion.Header>
                    <div className=" me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-house"
                        onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                      onClick={() => setSidebarOpen(true)}
                    >
                      Home
                    </p>

                    {/* </button> */}
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ul
                      className={`accordion_list list-unstyled fw-normal pb-0 small ${
                        isSidebarOpen ? "arrowshow" : "arrowHide"
                      }`}
                      style={{
                        display: isSidebarOpen ? "block" : "none",
                      }}
                    >
                      <Link
                        to="/advanceDashboard"
                        className="text-decoration-none"
                      >
                        <li className={isActive("/advanceDashboard")}>
                          <p key={2} className="insideDropdown_list" id={"2"}>
                            Advance Dashboard
                          </p>
                        </li>
                      </Link>

                      {user && user?.role_id === RoleId.Vendor && (
                        <Link
                          to="/profile"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/profile")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              My Store
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* *********************************************************Dashboard Ends*************************************************************** */}

              {/* *****************************************************   User Managements ********************************************************** */}

              {isAllow?.includes(IDS.Role.List) ||
              isAllow?.includes(IDS.User.List) ? (
                <Accordion.Item
                  eventKey="1"
                  className=""
                  onClick={() => handleClick("1")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      User Managements
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Role.List) ||
                      isAllow?.includes(IDS.Role.Add) ||
                      isAllow?.includes(IDS.Role.Edit) ||
                      isAllow?.includes(IDS.Role.Delete) ? (
                        <Link
                          to="/employee/role"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/employee/role")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              User Roles
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.User.List) ? (
                        <Link
                          to="/employee/employee-detail"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/employee/employee-detail",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Users
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* **************************************************   Employee Management Ends   ******************************************************* */}

              {/* ************************ Broker User Managements **************************  */}

              {(Number(user?.role_id) === RoleId.Broker ||
                Number(user?.role_id) === RoleId.Admin ||
                isAllow?.includes(IDS.Broker_User.List)) && (
                <Accordion.Item
                  eventKey="201"
                  className=""
                  onClick={() => handleClick("201")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faUserGroup} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Partner User Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {(Number(user?.role_id) === RoleId.Broker ||
                        Number(user?.role_id) === RoleId.Admin ||
                        isAllow?.includes(IDS.Broker_User.List)) && (
                        <Link
                          to="/broker/user"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/user")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Partner User
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* ***************** Broker User Managements  End *********************  */}


              {/* ************************ Broker Subscription Managements **************************  */}

              {(Number(user?.role_id) === RoleId.Broker ||
                Number(user?.role_id) === RoleId.Admin ||
                isAllow?.includes(IDS.Broker_Subscription.List)) && (
                <Accordion.Item
                  eventKey="291"
                  className=""
                  onClick={() => handleClick("291")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faMoneyBill} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Partner Subscriptions
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {(Number(user?.role_id) === RoleId.Broker ||
                        Number(user?.role_id) === RoleId.Admin ||
                        isAllow?.includes(IDS.Broker_Subscription.List)) && (
                        <Link
                          to="/broker/subscription"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/subscription")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Partner Subscription
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* ************************ Subscription Managements **************************  */}

              {(Number(user?.role_id) === RoleId.Admin &&
                isAllow?.includes(IDS.Subscription.List)) && (
                <Accordion.Item
                  eventKey="251"
                  className=""
                  onClick={() => handleClick("251")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faSuitcase} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Subscription Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {(Number(user?.role_id) === RoleId.Admin &&
                        isAllow?.includes(IDS.Subscription.List)) && (
                        <Link
                          to="/broker/plan"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/plan")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Subscription
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* ***************** Broker Wallet Managements *********************  */}

              {Number(user?.role_id) === RoleId.Broker ||
              Number(user?.role_id) === RoleId.Admin ||
              isAllow?.includes(IDS.Broker_Wallet.List) ||
              isAllow?.includes(IDS.Broker_Withdraw_History.List) ||
              isAllow?.includes(IDS.Broker_Wallet_History.List) ? (
                <Accordion.Item
                  eventKey="200"
                  className=""
                  onClick={() => handleClick("200")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      {/* <FontAwesomeIcon
                        icon="fa-solid fa-sliders"
                        // onClick={() => setIsOpen(!isOpen)}
                      /> */}
                      <FontAwesomeIcon icon={faWallet} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Partner Wallet Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {(Number(user?.role_id) === RoleId.Broker ||
                        Number(user?.role_id) === RoleId.Admin ||
                        isAllow?.includes(IDS.Broker_Wallet.List)) && (
                        <Link
                          to="/broker/wallet"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/wallet")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Partner Wallet
                            </p>
                          </li>
                        </Link>
                      )}

                      {(Number(user?.role_id) === RoleId.Broker ||
                        Number(user?.role_id) === RoleId.Admin ||
                        isAllow?.includes(IDS.Broker_Wallet_History.List)) && (
                        <Link
                          to="/broker/history"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/history")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Partner Wallet History
                            </p>
                          </li>
                        </Link>
                      )}

                      {(Number(user?.role_id) === RoleId.Broker ||
                        Number(user?.role_id) === RoleId.Admin ||
                        isAllow?.includes(
                          IDS.Broker_Withdraw_History.List,
                        )) && (
                        <Link
                          to="/broker/withdraw-list"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/broker/withdraw-list")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Partner Withdraw History
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* *********************** Broker Wallet Managements End ***********************  */}

              {/* ************************************************************  Vendors ************************************************************* */}

              {/* {isAllow?.includes(IDS.Vendor.List) ||
              isAllow?.includes(IDS.StoreCategory.List) ? (
                <Accordion.Item
                  eventKey="2"
                  className="mb-1"
                  onClick={() => handleClick("2")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-store"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Vendors Managment
                      {alerts?.pending_vendors > 0 && (
                        <span className="">
                          <FontAwesomeIcon
                            icon={faCircleExclamation}
                            className="blinking-alert"
                            style={{ color: "red", marginLeft: "8px" }}
                          />
                        </span>
                      )}
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.StoreCategory.List) ? (
                        <Link
                          to="/store/category"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/store/category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Store Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.RestaurantCategory.List) ? (
                        <Link
                          to="/store/restaurant-category"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/store/restaurant-category"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Restaurant Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Vendor.List) ? (
                        <Link to="/stores" className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/stores")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Vendors
                              {alerts?.pending_vendors > 0 && (
                                <span className="blinking-alert-count">
                                  {alerts?.pending_vendors}
                                </span>
                              )}
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                     
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Vendors End ************************************************************* */}

              {/* ************************************************************  Category requests ************************************************************* */}

              {/* {isAllow?.includes(IDS.Vendor.List) ||
              isAllow?.includes(IDS.StoreCategory.List) ? (
                <Accordion.Item
                  eventKey="42"
                  className="mb-1"
                  onClick={() => handleClick("42")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-store"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Category Requests
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.ProductCategory.List) ? (
                        <Link
                          to="/category-request"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/category-request")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Category Requests
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.ProductSubCategory.List) ? (
                        <Link
                          to="/sub-category-request"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/sub-category-request")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Sub Category Requests
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Vendors End ************************************************************* */}

              {/* ************************************************************  Customers ************************************************************* */}
              {!isBroker && isAllow?.includes(IDS.Customer.List) ? (
                <Accordion.Item
                  eventKey="9"
                  className="mb-"
                  onClick={() => handleClick("9")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-users"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Customer Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Customer.List) ? (
                        <Link
                          to="/customers"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/customers")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Customers Details
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* <Link
                        to="/employee/contact-us/:id"
                        className=" text-decoration-none  "
                      // className="text-decoration-none rounded "
                      >
                        <li
                          className={
                            isOpen
                              ? headerText.includes(
                                "/employee/contact-us/:id"
                              )
                                ? "active block"
                                : "none"
                              : "none"
                          }
                        >
                          <p
                            className="insideDropdown_list"
                            style={{ display: isOpen ? "block" : "none" }}
                          >
                            Contact Us
                          </p>
                        </li>
                      </Link> */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************  Customers End ************************************************************* */}

              {/* ************************************************************  Delivery Boy ************************************************************* */}
              {/* {isAllow?.includes(IDS.Customer.List) ||
                isAllow?.includes(IDS?.ContectUs?.List) ? (
                <Accordion.Item
                  eventKey="59"
                  // className="mb-1"
                  onClick={() => handleClick("59")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-users"
                      // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Delivery Boy Management
                      {alerts?.pending_delivery_boys > 0 && (
                        <span className="">
                          <FontAwesomeIcon
                            icon={faCircleExclamation}
                            className="blinking-alert"
                            style={{ color: "red", marginLeft: "8px" }}
                          />
                        </span>
                      )}
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                    // style={{
                    //   display: isSidebarOpen ? "block" : "none",
                    // }}
                    >
                      {isAllow?.includes(IDS.Customer.List) ? (
                        <Link
                          to="/delivery-boy"
                          className=" text-decoration-none  "
                        // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/delivery-boy")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Delivery Boy
                              {alerts?.pending_delivery_boys > 0 && (
                                <span className="blinking-alert-count">
                                  {alerts?.pending_delivery_boys}
                                </span>
                              )}
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Delivery Boy End ************************************************************* */}

              {/* ************************************************************  Products ************************************************************* */}

              {user?.role_id === RoleId.Admin ||
              (user?.Store_Detail?.s_category_id !== 1 &&
                (isAllow?.includes(IDS.Product.List) ||
                  isAllow?.includes(IDS.ProductCategory.List) ||
                  isAllow?.includes(IDS.ProductSubCategory.List) ||
                  isAllow?.includes(IDS.Colour.List) ||
                  isAllow?.includes(IDS.Size.List) ||
                  isAllow?.includes(IDS.Third_Variant.List) ||
                  isAllow?.includes(IDS.Product_Stock.List) ||
                  isAllow?.includes(IDS.OfferedProduct.List) ||
                  isAllow?.includes(IDS.RatingReview.List))) ? (
                <Accordion.Item
                  eventKey="7"
                  className="mb-"
                  onClick={() => handleClick("7")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon="fa fa-cubes" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Product Management
                      {/* {alerts?.pending_products > 0 && (
                        <span className="">
                          <FontAwesomeIcon
                            icon={faCircleExclamation}
                            className="blinking-alert"
                            style={{ color: "red", marginLeft: "8px" }}
                          />
                        </span>
                      )} */}
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{ display: isOpen ? "block" : "none" }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.ProductCategory.List) && (
                        <Link
                          to="/product/category"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/product/category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Product Category
                            </p>
                          </li>
                        </Link>
                      )}

                      {isAllow?.includes(IDS.ProductSubCategory.List) && (
                        <Link
                          to="/product/sub-category"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/product/sub-category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Product Sub Category
                            </p>
                          </li>
                        </Link>
                      )}

                      {/* {isAllow?.includes(IDS.ProductChildCategory.List) && (
                        <Link
                          to="/product/child-category"
                          className="text-decoration-none">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/product/child-category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Product Child Category
                            </p>
                          </li>
                        </Link>
                      )} */}

                      {/* {isAllow?.includes(IDS.Colour.List) && (
                        <Link
                          to="/masters/metal"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/metal")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Colour
                            </p>
                          </li>
                        </Link>
                      )} */}

                      {isAllow?.includes(IDS.Size.List) && (
                        <Link
                          to="/masters/size"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/size")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Size
                            </p>
                          </li>
                        </Link>
                      )}

                      {isAllow?.includes(IDS.Third_Variant.List) && (
                        <Link
                          to="/masters/diamond"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/diamond")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Third Variant
                            </p>
                          </li>
                        </Link>
                      )}

                      {isAllow?.includes(IDS.Product.List) && (
                        <Link to="/products" className="text-decoration-none">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/products")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Products
                              {/* {alerts?.pending_products > 0 && (
                                <span className="blinking-alert-count">
                                  {alerts?.pending_products}
                                </span>
                              )} */}
                            </p>
                          </li>
                        </Link>
                      )}
                      {isAllow?.includes(IDS.RatingReview.List) && (
                        <Link
                          to="/product/rating-reviews"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/product/rating-reviews")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Rating & Reviews
                            </p>
                          </li>
                        </Link>
                      )}
                      {isAllow?.includes(IDS.OfferedProduct.List) && (
                        <Link
                          to="/product/offered-products"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/product/offered-products",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Offered Products
                            </p>
                          </li>
                        </Link>
                      )}

                      {isAllow?.includes(IDS.Product_Stock.List) && (
                        <Link
                          to="/product/product-stock"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/product/product-stock")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Products Stock
                            </p>
                          </li>
                        </Link>
                      )}

                      {/* {isAllow?.includes(IDS.Farmer.List) && (
                        <Link
                          to="/masters/farmer"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/farmer")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Farmer
                            </p>
                          </li>
                        </Link>
                      )} */}

                      {/* {isAllow?.includes(IDS.Farmer_Detail.List) && (
                        <Link
                          to="/masters/farmerdetail"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/farmerdetail")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Farmer Details
                            </p>
                          </li>
                        </Link>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}

              {/* ************************************************************  Products End ************************************************************* */}

              {/* ************************************************************  Foods ************************************************************* */}

              {/* {user?.role_id === RoleId.Admin ||
              (user?.Store_Detail?.s_category_id === 1 &&
                isAllow?.includes(IDS.Product.List)) ||
              isAllow?.includes(IDS.ProductCategory.List) ||
              isAllow?.includes(IDS.ProductSubCategory.List) ||
              isAllow?.includes(IDS.ProductChildCategory.List) ? (
                <Accordion.Item
                  eventKey="8"
                  className="mb-1"
                  onClick={() => handleClick("8")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-pizza-slice"

                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Food Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.FoodCategory.List) ? (
                        <Link
                          to="/food/category"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/food/category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Food Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.FoodSubCategory.List) ? (
                        <Link
                          to="/food/sub-category"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/food/sub-category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Food Sub Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.FoodAddOnCategory.List) ? (
                        <Link
                          to="/food/add-on-categories"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/food/add-on-categories")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Food Add On Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.FoodAddOn.List) ? (
                        <Link
                          to="/food/add-ons"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/food/add-ons")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Food Add On
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Product.List) ? (
                        <Link
                          to="/Foods/:id"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/Foods/:id")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Foods
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.OfferedProduct.List) && (
                        <Link
                          to="/foods/offered-foods"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/foods/offered-foods")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Offered Items
                            </p>
                          </li>
                        </Link>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Foods End ************************************************************* */}

              {/* ************************************************************  Orders ************************************************************* */}

              {isAllow?.includes(IDS.Order.List) ? (
                <Accordion.Item
                  eventKey="6"
                  className="mb-"
                  onClick={() => handleClick("6")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon="fa fa-shopping-cart" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Order Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {/* {isAllow?.includes(IDS.Order.List) ? (
                        <Link
                          to="/orders/all-orders"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/orders/all-orders")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Orders
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {isAllow?.includes(IDS.Order.List) ? (
                        <Link
                          to="/orders/all-orders"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/orders/all-orders")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              All Orders
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* {isAllow?.includes(IDS.Customer.List) ||
              isAllow?.includes(IDS?.ContectUs?.List) ? (
                <Accordion.Item
                  eventKey="21"
                  className="mb-1"
                  onClick={() => handleClick("21")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-users"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Subscription Order Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Customer.List) ? (
                        <Link
                          to="/subscription-order/order"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/subscription-order/order"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Order
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Orders End ************************************************************* */}

              {/* ************************************************************  Coupons ************************************************************* */}

              {isAllow?.includes(IDS.Coupon.List) ? (
                <Accordion.Item
                  eventKey="46"
                  className="mb-"
                  onClick={() => handleClick("46")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon="fa-solid fa-ticket" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Coupons
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/coupons/coupon"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/coupons/coupon")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Coupon
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* {isAllow?.includes(IDS.Coupon.List) ? (
                <Accordion.Item
                  eventKey="111"
                  className="mb-1"
                  onClick={() => handleClick("111")}>
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon="fa-solid fa-ticket" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Currency
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/masters/exchange-rate"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/exchange-rate")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Currency
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* {isAllow?.includes(IDS.Coupon.List) ? (
                <Accordion.Item
                  eventKey="47"
                  className="mb-1"
                  onClick={() => handleClick("47")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon="fa-solid fa-ticket" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Miscellaneous Data
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/miscellaneous/reason"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/miscellaneous/reason")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Miscellaneous Reason
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/miscellaneous/data"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/miscellaneous/data")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Miscellaneous Data
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Coupon End ************************************************************* */}

              {/* ************************************************************   Masters Start ************************************************************* */}

              {isAllow?.includes(IDS.Brand.List) ||
              isAllow?.includes(IDS.CountryCode.List) ||
              isAllow?.includes(IDS.CancelReason.List) ||
              isAllow?.includes(IDS.ReturnReason.List) ? (
                <Accordion.Item
                  eventKey="3"
                  className="mb-"
                  onClick={() => handleClick("3")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      {/* <FontAwesomeIcon
                        icon="fa-solid fa-gear"
                        // onClick={() => setIsOpen(!isOpen)}
                      /> */}
                      <FontAwesomeIcon icon={faDatabase} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Masters
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.CountryCode.List) ? (
                        <Link
                          to="/master/country-code"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/master/country-code")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Country Code
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.Brand.List) ? (
                        <Link
                          to="/masters/brands"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/brands")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Brands
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(IDS.Unit.List) ? (
                        <Link
                          to="/masters/units"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/units")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Units
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.Unit.List) ? (
                        <Link
                          to="/masters/plan-feature"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/plan-feature")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Plan Feature
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.PaymentType.List) ? (
                        <Link
                          to="/masters/payment-type"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/payment-type")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Payment Types
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.GalleryImage.List) ? (
                        <Link
                          to="/image-gallery"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/image-gallery")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Image Gallery
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {isAllow?.includes(IDS.CancelReason.List) ? (
                        <Link
                          to="/master/cancel-reason"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/master/cancel-reason")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Cancel Reason
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(IDS.RejectReasons.List) ? (
                        <Link
                          to="/master/reject-reason"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/master/reject-reason")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Reject Reasons
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {isAllow?.includes(IDS.ReturnReason.List) ? (
                        <Link
                          to="/master/return-reason"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/master/return-reason")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Return Reason
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {/* {isAllow?.includes(IDS.ReturnReason.List) ? (
                        <Link
                          to="/settings/master/time-slot"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                  "/settings/master/time-slot"
                                )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Time Slot
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.Crop.List) ? (
                        <Link
                          to="/masters/crop"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/crop")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Benefits
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.Collection_Center.List) ? (
                        <Link
                          to="/masters/collectioncenter"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                  "/masters/collectioncenter"
                                )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Collection Center
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.Review_Reason.List) ? (
                        <Link
                          to="/masters/reviewreason"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/masters/reviewreason")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Review Reason
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* {isAllow?.includes(IDS.Customer.List) ||
                isAllow?.includes(IDS?.ContectUs?.List) ? (
                <Accordion.Item
                  eventKey="200"
                  // className="mb-1"
                  onClick={() => handleClick("200")}>
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa fa-users"
                      // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Delivery Range
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                    // style={{
                    //   display: isSidebarOpen ? "block" : "none",
                    // }}
                    >
                      {isAllow?.includes(IDS.Customer.List) ? (
                        <Link
                          to="/master/delivery-range"
                          className=" text-decoration-none  "
                        // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/master/delivery-range")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Delivery Range
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                    
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Masters End ************************************************************* */}

              {/* ************************************************************   Settings Start ************************************************************* */}

              {isAllow?.includes(IDS.HomeBanner.List) ||
              isAllow?.includes(IDS.FaqCategory.List) ||
              isAllow?.includes(IDS.Best_Deals.List) ||
              isAllow?.includes(IDS.Faq.List) ||
              isAllow?.includes(IDS.TermsAndCondition.List) ||
              isAllow?.includes(IDS.PrivacyPolicy.List) ||
              isAllow?.includes(IDS.AppSetup.List) ? (
                <Accordion.Item
                  eventKey="4"
                  className="mb-"
                  onClick={() => handleClick("4")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-gear"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Settings
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.AppSetup.List) ? (
                        <Link
                          to="/settings/app-setup"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/app-setup")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              App Setup
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.SocialLink.List) ? (
                        <Link
                          to="/settings/social-links"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/social-links")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Social Links
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.HomeBanner.List) ? (
                        <Link
                          to="/settings/home-banner"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/home-banner")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Home Banner
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Best_Deals.List) ? (
                        <Link
                          to="/settings/best-deal"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/best-deal")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Best Deals
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(IDS.HomeBanner.List) ? (
                        <Link
                          to="/settings/store-banner"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/store-banner")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Store Banner
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(IDS.HomeBanner.List) ? (
                        <Link
                          to="/settings/add-banner"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/add-banner")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Advertisement Banner
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {isAllow?.includes(IDS.FaqCategory.List) ? (
                        <Link
                          to="/settings/faq-categories"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/faq-categories",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              FAQ Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Faq.List) ? (
                        <Link
                          to="/settings/faqs"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/faqs")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              FAQs
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.TermsAndCondition.List) ? (
                        <Link
                          to="/settings/terms-and-condition"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/terms-and-condition",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Terms And Condition
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.PrivacyPolicy.List) ? (
                        <Link
                          to="/settings/privacy-policy"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/privacy-policy",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Privacy Policy
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.PrivacyPolicy.List) ? (
                        <Link
                          to="/settings/help"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/help")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Get Help
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(IDS.HomeWatchAndShop.List) ? (
                        <Link
                          to="/settings/home-watch-and-shop"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/home-watch-and-shop",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Home Watch and Shop
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* =========================   Child Details  ============================= */}

              {isAllow?.includes(IDS.Child_Type.List) ||
              isAllow?.includes(IDS.Relation_Type.List) ||
              isAllow?.includes(IDS.Expecting_Type.List) ? (
                <Accordion.Item
                  eventKey="199"
                  className="mb-"
                  onClick={() => handleClick("199")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      {/* <FontAwesomeIcon icon="fa-solid fa-ticket" /> */}
                      <FontAwesomeIcon icon={faChild} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Child Details
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Child_Type.List) ? (
                        <Link
                          to="/settings/child"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/child")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Child Types
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Relation_Type.List) ? (
                        <Link
                          to="/settings/relation-type"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/relation-type")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Relation Types
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Expecting_Type.List) ? (
                        <Link
                          to="/settings/expecting-type"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/expecting-type",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Expecting Types
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************  Settings End ************************************************************* */}

              {/* ************************************************************   Subscriptions Start ************************************************************* */}

              {/* {isAllow?.includes(IDS.Plan.List) ||
              isAllow?.includes(IDS.Subscription.List) ||
              isAllow?.includes(IDS.Appointment.List) ? (
                <Accordion.Item
                  eventKey="5"
                  className="mb-1"
                  onClick={() => handleClick("5")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-calendar-check"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Subscription
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Plan.List) ? (
                        <Link
                          to="/subscription/plans"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/subscription/plans")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Plans
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.Appointment.List) ? (
                        <Link
                          to="/subscription/appointment"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/subscription/appointment"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Appointment
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.Subscription.List) ? (
                        <Link
                          to="/subscriptions"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/subscriptions")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Subscriptions
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Subscription.List) ? (
                        <Link
                          to="/doctor-subscriptions"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/doctor-subscriptions")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Doctor Subscriptions
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}

              {/* ************************************************************  Subscriptions End ************************************************************* */}
              {isAllow?.includes(IDS.Receiving_Order.List) ||
              isAllow?.includes(IDS.Purchase_Product.List) ||
              isAllow?.includes(IDS.Supplier.List) ? (
                <Accordion.Item
                  eventKey="20"
                  className=""
                  onClick={() => handleClick("20")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-calendar-check"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Purchase Product
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Supplier.List) ? (
                        <Link
                          to="/purchase-product/supplier"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/purchase-product/supplier",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Supplier
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.Purchase_Product.List) ? (
                        <Link
                          to="/purchase-product/purchase-product"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/purchase-product/purchase-product",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Purchase Product
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(IDS.Receiving_Order.List) ? (
                        <Link
                          to="/purchase-product/receiving-order"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/purchase-product/receiving-order",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Receiving Order
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************   my-wallet Start ************************************************************* */}

              {isAllow?.includes(IDS.Wallet.List) ||
              isAllow?.includes(IDS.Withdraw_History.List) ? (
                <Accordion.Item
                  eventKey="16"
                  className="mb-"
                  onClick={() => handleClick("16")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-wallet"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Wallet
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Wallet.List) ? (
                        <Link
                          to="/my-wallet"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/my-wallet")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Wallet
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Withdraw_History.List) ? (
                        <Link
                          to="/wallet/withdraw-request"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/wallet/withdraw-request",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Withdraw Request
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************  my-wallet End ************************************************************* */}

              {/* ************************************************************  Location ************************************************************* */}
              {isAllow?.includes(IDS.Country.List) ||
              isAllow?.includes(IDS.State.List) ||
              isAllow?.includes(IDS.City.List) ||
              isAllow?.includes(IDS.Pincode.List) ? (
                <Accordion.Item
                  eventKey="10"
                  className="mb-"
                  onClick={() => handleClick("10")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon
                        icon="fa-solid fa-map-location-dot"

                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Location
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-0 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(IDS.Country.List) ? (
                        <Link
                          to="/settings/location/country"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/country",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Country
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.State.List) ? (
                        <Link
                          to="/settings/location/state"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/state",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              State
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.City.List) ? (
                        <Link
                          to="/settings/location/city"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/location/city")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              City
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Pincode.List) ? (
                        <Link
                          to="/settings/location/pincode"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/pincode",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Pincode
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(IDS.Area.List) ||
                        isAllow?.includes(IDS.Area.Add) ||
                        isAllow?.includes(IDS.Area.Edit) ||
                        isAllow?.includes(IDS.Area.Delete) ? (
                        <Link
                          to="/settings/location/area"
                          className=" text-decoration-none  "
                        // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/location/area")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Area
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************  Location End ************************************************************* */}

              {/* ************************************************************  About us Content ************************************************************* */}

              {isAllow?.includes(IDS.AboutUs.List) ||
              isAllow?.includes(IDS.Counter.List) ||
              isAllow?.includes(IDS.Expert_Team.List) ? (
                <Accordion.Item
                  eventKey="99"
                  className="mb-"
                  onClick={() => handleClick("99")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      {/* <FontAwesomeIcon icon="fa-solid fa-ticket" /> */}
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      About Us Details
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.AboutUs.List) ? (
                        <Link
                          to="/settings/about-us"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/about-us")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              About Us
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(IDS.Counter.List) && (
                        <Link
                          to="/setting/counter"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/setting/counter")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Counter
                            </p>
                          </li>
                        </Link>
                      )}

                      {isAllow?.includes(IDS.Expert_Team.List) && (
                        <Link
                          to="/setting/expert-team"
                          className="text-decoration-none"
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/setting/expert-team")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Expert Team
                            </p>
                          </li>
                        </Link>
                      )}

                      {/* {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/aboutus/founding-farmers"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/aboutus/founding-farmers",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Founding Farmers
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                      {/* ----------------------- */}

                      {/* {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/aboutus/about-us-content"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/aboutus/about-us-content",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              About Us Content
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* ----------------------- */}

                      {/* {isAllow?.includes(IDS.Coupon.List) ? (
                        <Link
                          to="/aboutus/achievement"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/aboutus/achievement")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Achievements and Acknowledgement
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************  About us Content End ************************************************************* */}

              {/* ************************************************************ Blog ************************************************************* */}

              {isAllow?.includes(IDS.Blog.List) ? (
                <Accordion.Item
                  eventKey="98"
                  className="mb-"
                  onClick={() => handleClick("98")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faNewspaper} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Blog Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Blog.List) ? (
                        <Link to="/blog" className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/blog")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Blog
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************  Blog End ************************************************************* */}

              {/* ************************************************************ Contact Us Form ************************************************************* */}

              {isAllow?.includes(IDS.Contact_Us_Form.List) ? (
                <Accordion.Item
                  eventKey="09"
                  className="mb-"
                  onClick={() => handleClick("09")}
                >
                  <Accordion.Header>
                    <div className="me-3">
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Contact Us Forms
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul className="accordion_list list-unstyled fw-normal pb-0 small">
                      {isAllow?.includes(IDS.Contact_Us_Form.List) ? (
                        <Link
                          to="/contact-us-form"
                          className=" text-decoration-none  "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/contact-us-form")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Contact Us Form
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}

              {/* ************************************************************ Contact Us Form End ************************************************************* */}
            </Accordion>
          </ul>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
